<template>
    <section class="neighborhoods-carousel" v-if="neighborhoods && neighborhoods.length > 0">
        <div class="component-header container hd-container">
            <h2 class="headline-1"><NuxtLink :to="url">Neighborhood Areas</NuxtLink></h2>
            <NuxtLink class="view-all" :to="url">View All</NuxtLink>
        </div>
        <div class="hd-container">
            <GlobalCarousel padding="20%" :fullWidth="false" :items="neighborhoods">
                <template #item="item">
                    <CardsNeighborhood class="neighborhood-card" :item="item" imageStyle="square" />
                </template>
            </GlobalCarousel>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        neighborhoods: {
            type: Array,
            required: true,
            default: [],
        },
    });

    const { neighborhoods } = toRefs(props);

    const route = useRoute();
    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/neighborhoods/';
        else return '/neighborhoods/';
    });
</script>

<style lang="scss">
    .neighborhoods-carousel {
        padding: 30px 0;

        .carousel-component {
            .carousel-inner {
                .carousel-item {
                    flex: 0 0 50%;

                    @media (min-width: $tablet) {
                        flex: 0 0 39%;

                        .headline-3 {
                            font-size: 18px;
                        }
                    }
                }
            }
        }

        // The square image box now lives in Cards/neighborhood.vue, keyed off
        // the imageStyle="square" prop this carousel already passes — reaching
        // in from here was losing to the card's own scoped rule depending on
        // stylesheet order.

        .component-header {
            h2 {
                margin-right: 30px;
            }
        }
    }
</style>
